import { WarehouseLocality } from '../../../../../api/warehouse/warehouseApiTypes';
import { utils } from '../../../../../utils/utils';

export interface Edit {
  name?: string;
  street?: string;
  houseNumber?: string;
  city?: string;
  postcode?: string;
  countryCode?: string;
  phone?: string;
  isDefault?: boolean;
}

export type Status = 'loading' | 'ready' | 'saving';

export interface Data {
  warehouseLocality?: WarehouseLocality;
}

export interface State {
  status: Status;
  data: Data;
  edit: Edit;
}

type EditSetAction = { type: 'edit/set', payload: Edit };
type EditResetAction = { type: 'edit/reset' };
type DataLoadedAction = { type: 'data/loaded', payload: Data };
type StatusSetAction = { type: 'status/set', payload: Status };
export type Action = EditSetAction | EditResetAction | DataLoadedAction | StatusSetAction;

export const initialState: State = {
  status: 'ready',
  data: {
    warehouseLocality: undefined,
  },
  edit: {
    name: '',
    street: '',
    houseNumber: '',
    city: '',
    postcode: '',
    countryCode: '',
    phone: '',
    isDefault: false,
  },
};

export function mapToEdit(warehouseLocality?: WarehouseLocality): Edit {
  return {
    name: utils.defaultToEmpty(warehouseLocality?.name),
    street: utils.defaultToEmpty(warehouseLocality?.street),
    houseNumber: utils.defaultToEmpty(warehouseLocality?.houseNumber),
    city: utils.defaultToEmpty(warehouseLocality?.city),
    postcode: utils.defaultToEmpty(warehouseLocality?.postcode),
    countryCode: utils.defaultToEmpty(warehouseLocality?.countryCode),
    phone: utils.defaultToEmpty(warehouseLocality?.phone),
    isDefault: warehouseLocality?.isDefault ?? false,
  };
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'edit/set': {
      return { ...state, edit: action.payload };
    }
    case 'edit/reset': {
      return { ...state, edit: mapToEdit(state.data.warehouseLocality) };
    }
    case 'data/loaded': {
      return {
        ...state,
        status: 'ready',
        data: action.payload,
        edit: mapToEdit(action.payload.warehouseLocality),
      };
    }
    case 'status/set': {
      return { ...state, status: action.payload };
    }
    default:
      return state;
  }
}
